/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UsersBaseService } from '../users-base-service';
import { UsersApiConfiguration } from '../users-api-configuration';
import { UsersStrictHttpResponse } from '../users-strict-http-response';

import { UsersPresignedDownloadUrlResponseDto } from '../models/users-presigned-download-url-response-dto';
import { UsersPresignedUploadResponseDto } from '../models/users-presigned-upload-response-dto';
import { tenantContractControllerAccept } from '../fn/tenants/tenant-contract-controller-accept';
import { TenantContractControllerAccept$Params } from '../fn/tenants/tenant-contract-controller-accept';
import { tenantContractControllerFindOne } from '../fn/tenants/tenant-contract-controller-find-one';
import { TenantContractControllerFindOne$Params } from '../fn/tenants/tenant-contract-controller-find-one';
import { tenantContractControllerRequestDocumentUrl } from '../fn/tenants/tenant-contract-controller-request-document-url';
import { TenantContractControllerRequestDocumentUrl$Params } from '../fn/tenants/tenant-contract-controller-request-document-url';
import { UsersTenantContractResponseDto } from '../models/users-tenant-contract-response-dto';
import { UsersTenantResponseDto } from '../models/users-tenant-response-dto';
import { tenantsControllerCreate } from '../fn/tenants/tenants-controller-create';
import { TenantsControllerCreate$Params } from '../fn/tenants/tenants-controller-create';
import { tenantsControllerFindAll } from '../fn/tenants/tenants-controller-find-all';
import { TenantsControllerFindAll$Params } from '../fn/tenants/tenants-controller-find-all';
import { tenantsControllerFindByName } from '../fn/tenants/tenants-controller-find-by-name';
import { TenantsControllerFindByName$Params } from '../fn/tenants/tenants-controller-find-by-name';
import { tenantsControllerFindOne } from '../fn/tenants/tenants-controller-find-one';
import { TenantsControllerFindOne$Params } from '../fn/tenants/tenants-controller-find-one';
import { tenantsControllerGenerateCustomTemplateDownloadUrl } from '../fn/tenants/tenants-controller-generate-custom-template-download-url';
import { TenantsControllerGenerateCustomTemplateDownloadUrl$Params } from '../fn/tenants/tenants-controller-generate-custom-template-download-url';
import { tenantsControllerGenerateCustomTemplateUploadUrl } from '../fn/tenants/tenants-controller-generate-custom-template-upload-url';
import { TenantsControllerGenerateCustomTemplateUploadUrl$Params } from '../fn/tenants/tenants-controller-generate-custom-template-upload-url';
import { tenantsControllerRemove } from '../fn/tenants/tenants-controller-remove';
import { TenantsControllerRemove$Params } from '../fn/tenants/tenants-controller-remove';
import { tenantsControllerUpdate } from '../fn/tenants/tenants-controller-update';
import { TenantsControllerUpdate$Params } from '../fn/tenants/tenants-controller-update';

@Injectable({ providedIn: 'root' })
export class UsersTenantsService extends UsersBaseService {
  constructor(config: UsersApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tenantsControllerFindAll()` */
  static readonly TenantsControllerFindAllPath = '/o2-users/tenants';

  /**
   * Retrieve all tenants.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsControllerFindAll$Response(params?: TenantsControllerFindAll$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<Array<UsersTenantResponseDto>>> {
    const obs = tenantsControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all tenants.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsControllerFindAll(params?: TenantsControllerFindAll$Params, context?: HttpContext): Observable<Array<UsersTenantResponseDto>> {
    const resp = this.tenantsControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<Array<UsersTenantResponseDto>>): Array<UsersTenantResponseDto> => r.body)
    );
  }

  /** Path part for operation `tenantsControllerCreate()` */
  static readonly TenantsControllerCreatePath = '/o2-users/tenants';

  /**
   * Create a new tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsControllerCreate$Response(params: TenantsControllerCreate$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantResponseDto>> {
    const obs = tenantsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsControllerCreate(params: TenantsControllerCreate$Params, context?: HttpContext): Observable<UsersTenantResponseDto> {
    const resp = this.tenantsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersTenantResponseDto>): UsersTenantResponseDto => r.body)
    );
  }

  /** Path part for operation `tenantsControllerFindOne()` */
  static readonly TenantsControllerFindOnePath = '/o2-users/tenants/{id}';

  /**
   * Retrieve a tenant by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsControllerFindOne$Response(params: TenantsControllerFindOne$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantResponseDto>> {
    const obs = tenantsControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a tenant by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsControllerFindOne(params: TenantsControllerFindOne$Params, context?: HttpContext): Observable<UsersTenantResponseDto> {
    const resp = this.tenantsControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersTenantResponseDto>): UsersTenantResponseDto => r.body)
    );
  }

  /** Path part for operation `tenantsControllerRemove()` */
  static readonly TenantsControllerRemovePath = '/o2-users/tenants/{id}';

  /**
   * Delete a tenant by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsControllerRemove$Response(params: TenantsControllerRemove$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantResponseDto>> {
    const obs = tenantsControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a tenant by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsControllerRemove(params: TenantsControllerRemove$Params, context?: HttpContext): Observable<UsersTenantResponseDto> {
    const resp = this.tenantsControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersTenantResponseDto>): UsersTenantResponseDto => r.body)
    );
  }

  /** Path part for operation `tenantsControllerUpdate()` */
  static readonly TenantsControllerUpdatePath = '/o2-users/tenants/{id}';

  /**
   * Update a tenant by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsControllerUpdate$Response(params: TenantsControllerUpdate$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantResponseDto>> {
    const obs = tenantsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a tenant by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsControllerUpdate(params: TenantsControllerUpdate$Params, context?: HttpContext): Observable<UsersTenantResponseDto> {
    const resp = this.tenantsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersTenantResponseDto>): UsersTenantResponseDto => r.body)
    );
  }

  /** Path part for operation `tenantsControllerFindByName()` */
  static readonly TenantsControllerFindByNamePath = '/o2-users/tenants/name/{name}';

  /**
   * Retrieve a tenant by name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsControllerFindByName()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsControllerFindByName$Response(params: TenantsControllerFindByName$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantResponseDto>> {
    const obs = tenantsControllerFindByName(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a tenant by name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsControllerFindByName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsControllerFindByName(params: TenantsControllerFindByName$Params, context?: HttpContext): Observable<UsersTenantResponseDto> {
    const resp = this.tenantsControllerFindByName$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersTenantResponseDto>): UsersTenantResponseDto => r.body)
    );
  }

  /** Path part for operation `tenantsControllerGenerateCustomTemplateUploadUrl()` */
  static readonly TenantsControllerGenerateCustomTemplateUploadUrlPath = '/o2-users/tenants/custom-templates/upload-url/{name}';

  /**
   * Generate presigned URL for custom template upload.
   *
   * Creates a presigned POST URL with embedded metadata for uploading a custom .docx template to S3. The URL expires after 180 seconds. The S3 policy enforces a strict docx Content-Type and tenant/templateType isolation. The client must POST to the returned URL with all fields from the response.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsControllerGenerateCustomTemplateUploadUrl()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsControllerGenerateCustomTemplateUploadUrl$Response(params: TenantsControllerGenerateCustomTemplateUploadUrl$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersPresignedUploadResponseDto>> {
    const obs = tenantsControllerGenerateCustomTemplateUploadUrl(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Generate presigned URL for custom template upload.
   *
   * Creates a presigned POST URL with embedded metadata for uploading a custom .docx template to S3. The URL expires after 180 seconds. The S3 policy enforces a strict docx Content-Type and tenant/templateType isolation. The client must POST to the returned URL with all fields from the response.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsControllerGenerateCustomTemplateUploadUrl$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsControllerGenerateCustomTemplateUploadUrl(params: TenantsControllerGenerateCustomTemplateUploadUrl$Params, context?: HttpContext): Observable<UsersPresignedUploadResponseDto> {
    const resp = this.tenantsControllerGenerateCustomTemplateUploadUrl$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersPresignedUploadResponseDto>): UsersPresignedUploadResponseDto => r.body)
    );
  }

  /** Path part for operation `tenantsControllerGenerateCustomTemplateDownloadUrl()` */
  static readonly TenantsControllerGenerateCustomTemplateDownloadUrlPath = '/o2-users/tenants/custom-templates/download-url/{name}';

  /**
   * Generate presigned URL for custom template download.
   *
   * Creates a presigned GET URL for downloading a custom template from S3. The URL expires after 180 seconds. Validates tenant isolation against the provided S3 key.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsControllerGenerateCustomTemplateDownloadUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsControllerGenerateCustomTemplateDownloadUrl$Response(params: TenantsControllerGenerateCustomTemplateDownloadUrl$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersPresignedDownloadUrlResponseDto>> {
    const obs = tenantsControllerGenerateCustomTemplateDownloadUrl(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Generate presigned URL for custom template download.
   *
   * Creates a presigned GET URL for downloading a custom template from S3. The URL expires after 180 seconds. Validates tenant isolation against the provided S3 key.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsControllerGenerateCustomTemplateDownloadUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsControllerGenerateCustomTemplateDownloadUrl(params: TenantsControllerGenerateCustomTemplateDownloadUrl$Params, context?: HttpContext): Observable<UsersPresignedDownloadUrlResponseDto> {
    const resp = this.tenantsControllerGenerateCustomTemplateDownloadUrl$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersPresignedDownloadUrlResponseDto>): UsersPresignedDownloadUrlResponseDto => r.body)
    );
  }

  /** Path part for operation `tenantContractControllerFindOne()` */
  static readonly TenantContractControllerFindOnePath = '/o2-users/tenants/contract/{tenant}';

  /**
   * Retrieve the contract the referent of the tenant has still to accept.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantContractControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantContractControllerFindOne$Response(params: TenantContractControllerFindOne$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantContractResponseDto>> {
    const obs = tenantContractControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve the contract the referent of the tenant has still to accept.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantContractControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantContractControllerFindOne(params: TenantContractControllerFindOne$Params, context?: HttpContext): Observable<UsersTenantContractResponseDto> {
    const resp = this.tenantContractControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersTenantContractResponseDto>): UsersTenantContractResponseDto => r.body)
    );
  }

  /** Path part for operation `tenantContractControllerRequestDocumentUrl()` */
  static readonly TenantContractControllerRequestDocumentUrlPath = '/o2-users/tenants/contract/{tenant}/document-url';

  /**
   * Ask Rocket a fresh link to the document of the contract.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantContractControllerRequestDocumentUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantContractControllerRequestDocumentUrl$Response(params: TenantContractControllerRequestDocumentUrl$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<void>> {
    const obs = tenantContractControllerRequestDocumentUrl(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ask Rocket a fresh link to the document of the contract.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantContractControllerRequestDocumentUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantContractControllerRequestDocumentUrl(params: TenantContractControllerRequestDocumentUrl$Params, context?: HttpContext): Observable<void> {
    const resp = this.tenantContractControllerRequestDocumentUrl$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantContractControllerAccept()` */
  static readonly TenantContractControllerAcceptPath = '/o2-users/tenants/contract/{tenant}/accept';

  /**
   * Accept the contract as the referent of the tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantContractControllerAccept()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantContractControllerAccept$Response(params: TenantContractControllerAccept$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<void>> {
    const obs = tenantContractControllerAccept(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Accept the contract as the referent of the tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantContractControllerAccept$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantContractControllerAccept(params: TenantContractControllerAccept$Params, context?: HttpContext): Observable<void> {
    const resp = this.tenantContractControllerAccept$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<void>): void => r.body)
    );
  }

}
